var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout-navbar"},[_c('div',{staticClass:"navbar"},_vm._l((_vm.menus),function(menu,index){return _c('div',{key:index,staticClass:"menu",class:{
        active: menu.meta.routeID == _vm.activeRouteID,
      },on:{"click":function($event){return _vm.handleClick(menu.meta.routeID)}}},[_c('i',{class:menu.meta.icon}),_c('div',[_vm._v(_vm._s(menu.meta.title))])])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }